module.exports = __webpack_public_path__ + "img/2gh_Events.92b5a832.png";